import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

interface SyncToGoogleAdsParams {
	workspaceId: string
	connectionId: string
	campaignId: string
	cellIds: string[]
	isFullReplace: boolean
}

export const useSyncToGoogleAds = () => {
	const authFetch = useHoneyGridApiFetch()

	return useMutation({
		mutationFn: async ({
			workspaceId,
			connectionId,
			campaignId,
			cellIds,
			isFullReplace,
		}: SyncToGoogleAdsParams) => {
			return authFetch(
				`workspaces/${workspaceId}/connections/${connectionId}/campaigns/${campaignId}/geo-targets`,
				{
					method: 'POST',
					body: { cellIds, isFullReplace },
				}
			)
		},
		onSuccess: () => {
			toast.success('Microtargets synced to Google Ads successfully')
		},
		onError: (error: any) => {
			console.error('Error syncing to Google Ads:', error)
			toast.error(error?.data?.error || 'Failed to sync microtargets to Google Ads')
		},
	})
}
